export enum SearchMode {
  Post = 'post',
  Kol = 'kol',
  SimilarKol = 'similarKol',
}
